/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Factual_Wild_Rabbit_DevourInputs */

const fr_factual_wild_rabbit_devour = /** @type {(inputs: Factual_Wild_Rabbit_DevourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrez le programme`)
};

/**

* @param {Factual_Wild_Rabbit_DevourInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const factual_wild_rabbit_devour = /** @type {((inputs?: Factual_Wild_Rabbit_DevourInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Factual_Wild_Rabbit_DevourInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_factual_wild_rabbit_devour(inputs)
});